import { alpha, createTheme } from '@mui/material/styles';

export const colors = {
	black: '#000000',
	green: '#057871',
	blue: '#1976d2',
	darkBlue: '#1a3e72',
	purple: '#482E51',
	purpleDark: '#3c2640',
	purpleBlackish: '#170e18',
	purpleLight: '#b2a5b1',
	purpleWhitish: '#6D667F',
	middleLicac: '#6A588D',
	yellow: '#D4A712',
	darkRed: '#8e0e44',
	wine: '#5d092c',
	red: '#fb3b3b',
	lightGreen: '#459F78',
	paleGreen: '#88C493',
	darkGreen: '#077871',
	white: '#FFFFFF',
	beige: '#e0d6c4',
	beigeDark: '#bab3a8',
	beigeLight: '#eee8de',
	beigeWhite: '#f2eee5',
	secondary: '#e2ddde',
	border: '#d1d5db',
	grayscale900: '#303F5A',
	grayscale800: '#a0a0a0',
	grayscale700: '#5A647C',
	grayscale600: '#73798C',
	grayscale500: '#8F94A3',
	grayscale400: '#C5C3C6',
	grayscale300: '#E7E4DF',
	grayscale200: '#EEECE9',
	grayscale100: '#F7F5F0',
	grayscale50: '#FBFAF8',
	pillColor: '#57446e',
	pillTextColor: '#d1cde4',
	pillDarkTextColor: '#A09ABC',
};

const fonts = {
	aleo: 'Aleo',
	poppins: 'Poppins',
};

export const theme = createTheme({
	palette: {
		primary: {
			main: colors.purple,
			dark: colors.purpleDark,
			light: colors.white,
			contrastText: colors.grayscale50,
		},
		secondary: {
			main: colors.secondary,
			light: colors.grayscale50,
			dark: colors.purpleDark,
		},
		background: {
			default: colors.white,
			paper: colors.white,
		},
		error: {
			main: colors.darkRed,
			dark: colors.red,
		},
		text: {
			primary: colors.black,
			secondary: colors.grayscale700,
			disabled: colors.grayscale600,
		},
	},
	typography: {
		fontFamily: fonts.poppins,
		fontSize: 12,
		button: {
			textTransform: 'none',
			fontWeight: 500,
			fontSize: '1rem',
			lineHeight: 1.2,
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 4,
					fontSize: '1rem',
					'@media print': {
						display: 'none',
					},
				},
				contained: {
					boxShadow: 'none',
					'&:hover': {
						boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
					},
				},
				sizeSmall: {
					padding: '6px 8px',
					'&.MuiButton-contained': {
						padding: '7px 8px',
					},
				},
				sizeMedium: {
					padding: '9px 8px',
					'&.MuiButton-contained': {
						padding: '10px 8px',
					},
				},
				sizeLarge: {
					padding: '11px 17px',
					'&.MuiButton-contained': {
						padding: '12px 8px',
					},
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-root': {
						backgroundColor: colors.white,
						padding: '4px 10px 4px 10px',
					},
				},
			},
		},
		MuiCard: {
			styleOverrides: {
				root: {
					boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundColor: colors.white,
				},
			},
		},
		MuiDialog: {
			styleOverrides: {
				paper: {
					backgroundColor: colors.white,
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					borderRadius: 4,
				},
				label: {
					fontSize: '1rem',
					lineHeight: 1.3,
					fontWeight: 500,
				},
				filled: {
					borderColor: colors.grayscale200,
					backgroundColor: colors.grayscale200,
					color: colors.grayscale700,
				},
				outlined: {
					borderColor: colors.grayscale300,
					backgroundColor: colors.grayscale50,
					color: colors.grayscale800,
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					fontSize: '1rem',
					'&.Mui-disabled': {
						'&:before': {
							border: 'none',
							borderBottomStyle: 'hidden !important',
						},
						'& input': {
							textFillColor: alpha(colors.black, 0.7),
						},
					},
				},
				input: {
					height: '1.143rem',
					fontWeight: 400,
					fontSize: '1rem',
					lineHeight: 1.2,
					'&::placeholder': {
						opacity: 1,
						color: colors.grayscale500,
					},
				},
			},
		},
		MuiListItem: {
			styleOverrides: {
				root: {
					marginBottom: '.5rem',
					'&.Mui-selected': {
						backgroundColor: 'rgba(72, 46, 81, 0.08)',
					},
				},
			},
		},
	},
	shape: {
		borderRadius: 4,
	},
	spacing: 8,
});
